import { defineMessages } from 'react-intl';

export const messages: {
	heading: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	rovo: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	jira: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	jiraAlign: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	jiraServiceManagement: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	confluence: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	loom: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	trello: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	bitbucket: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	seeAll: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	heading: {
		id: 'twg-microsite.footer.apps.heading',
		defaultMessage: 'Products',
		description: 'Heading for the Products column in the footer',
	},
	rovo: {
		id: 'twg-microsite.footer.apps.rovo.do-not-translate',
		defaultMessage: 'Rovo',
		description: 'Footer link for the Rovo product in the Apps column',
	},
	jira: {
		id: 'twg-microsite.footer.apps.jira.do-not-translate',
		defaultMessage: 'Jira',
		description: 'Footer link for the Jira product in the Apps column',
	},
	jiraAlign: {
		id: 'twg-microsite.footer.apps.jiraAlign.do-not-translate',
		defaultMessage: 'Jira Align',
		description: 'Footer link for the Jira Align product in the Apps column',
	},
	jiraServiceManagement: {
		id: 'twg-microsite.footer.apps.jiraServiceManagement.do-not-translate',
		defaultMessage: 'Jira Service Management',
		description: 'Footer link for the Jira Service Management product in the Apps column',
	},
	confluence: {
		id: 'twg-microsite.footer.apps.confluence.do-not-translate',
		defaultMessage: 'Confluence',
		description: 'Footer link for the Confluence product in the Apps column',
	},
	loom: {
		id: 'twg-microsite.footer.apps.loom.do-not-translate',
		defaultMessage: 'Loom',
		description: 'Footer link for the Loom product in the Apps column',
	},
	trello: {
		id: 'twg-microsite.footer.apps.trello.do-not-translate',
		defaultMessage: 'Trello',
		description: 'Footer link for the Trello product in the Apps column',
	},
	bitbucket: {
		id: 'twg-microsite.footer.apps.bitbucket.do-not-translate',
		defaultMessage: 'Bitbucket',
		description: 'Footer link for the Bitbucket product in the Apps column',
	},
	seeAll: {
		id: 'twg-microsite.footer.apps.seeAll',
		defaultMessage: 'See all products →',
		description:
			'Call-to-action link at the bottom of the Products column linking to the full products list',
	},
});
